<template>
  <div>
    <div class="form-group row" v-if="hasCountries">
      <div class="col-md-12">
        <label for="nationality">Nationality</label>
        <select v-model="selected" class="form-control" id="nationality" name="nationality" required
                autocomplete="country" @change="refresh">
          <option selected disabled value="">Select Country of Citizenship</option>
          <option v-for="(country, code) in countries" :value="code">{{ country.name || code }}</option>
        </select>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg termsModal" ref="termsModal" id="accept-modal" tabindex="-1"
         role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg position-relative" role="document">
        <t-loader :loading="loading"></t-loader>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="TermsModalLabel" style="text-transform: capitalize; margin-left: 0 !important;">
              {{ title }} ({{
                version
              }})</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="max-height: 55vh; overflow-y: auto;">
            <div style="white-space: pre-wrap" v-if="terms">{{ terms }}</div>
            <slot v-else></slot>
          </div>
          <div class="modal-footer">
            <button type="button" @click="reject" class="btn btn-danger" data-dismiss="modal">Reject
            </button>
            <button type="button" @click="accept" class="btn btn-primary" data-dismiss="modal">Accept
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="form-check invoice" id="read-terms" :class="{ disabled: this.disabled}" @click.prevent="showTermsModal">
      <div class="checkbox-container" :class="{ active: accepted }">
        <i class="material-icons">check</i>
      </div>
      <label for="termsprivacy" class="form-check-label">
        I accept all <a href="#">{{ condition }}</a>
      </label>
      <input required type="checkbox" id="termsprivacy" class="form-check-input" v-model="accepted">
    </div>
  </div>
</template>

<script>
import 'axios';
import TLoader from '#/js/components/TLoader';

export default {
  name: 'AcceptTerms',
  components: {TLoader},
  props: {
    title: String,
    type: {
      type: String,
      default: 'register',
    },
    version: String,
    condition: String,
    nationality: String,
    countries: Object,
  },
  data() {
    return {
      loading: false,
      accepted: false,
      selected: this.nationality || '',
      terms: undefined,
    };
  },
  computed: {
    hasCountries() {
      return !!this.countries;
    },
    hasSelectedNationality() {
      return !!this.selected;
    },
    disabled() {
      return this.hasCountries && !this.hasSelectedNationality;
    },
  },
  methods: {
    showTermsModal() {
      if (this.disabled) return;
      $(this.$refs.termsModal).modal('show');
    },
    accept() {
      if (this.disabled) return;
      this.accepted = true;
      this.$emit('input', this.accepted);
    },
    reject() {
      if (this.disabled) return;
      this.accepted = false;
      this.$emit('input', this.accepted);
    },
    refresh() {
      this.loading = true;
      this.terms = '';
      this.accepted = false;
      axios.get(`/terms/${this.selected}?type=${this.type}`).then((response) => {
        this.terms = response.data.contents || '';
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  mounted() {
    if (!this.disabled) {
      this.refresh();
    }
  },
};

</script>

<style lang="scss" scoped>
#read-terms.disabled {
  pointer-events: none;
  opacity: .5;
}
</style>
